var map = {
	"./01-min.jpg": "0b33",
	"./02-min.jpg": "6962",
	"./03-min.jpg": "aee8",
	"./04-min.jpg": "a820",
	"./05-min.jpg": "53ba",
	"./06-min.jpg": "97f9",
	"./07-min.jpg": "b1d3",
	"./08-min.jpg": "a252",
	"./09-min.jpg": "aa7f",
	"./10-min.jpg": "0950",
	"./11-min.jpg": "d953",
	"./12-min.jpg": "045d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c60";